module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-cta-bg-886058898871f79fae37efc36daf7432.jpg";